import { FormikProps } from 'formik';

// MUI Theme
import { styled } from '@mui/material/styles';
import { Grid, Paper, TextField, Typography } from '@mui/material';

// Types
import { TranslationItem } from '../../../../types/Language';
import { Language } from '../../../../constants/Constants';

const PREFIX = 'labelForm';
const classes = {
  root: `${PREFIX}-root`,
  pointerCursor: `${PREFIX}-pointerCursor`,
  dropdown: `${PREFIX}-dropdown`,
  name: `${PREFIX}-name`,
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  [`& .${classes.root}`]: {
    '& .MuiTextField-root': {
      margin: theme.spacing(2),
    },
  },
  [`& .${classes.pointerCursor}`]: {
    cursor: 'pointer',
  },
  [`& .${classes.dropdown}`]: {
    width: 200,
    display: 'flex',
    justifyContent: 'left',
  },
  [`& .${classes.name}`]: {
    width: 200,
  },
  overflowX: 'auto',
  height: 350,
  marginLeft: 0,
}));

interface AddLanguageProps {
  formRef: FormikProps<TranslationItem>;
  isoCode: string | null;
  isEditing: boolean;
}

const AddLanguage = ({ formRef, isoCode, isEditing }: AddLanguageProps) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formValues = {
      isoCode: isoCode ?? formRef.values.isoCode ?? '',
      key: formRef.values.key ?? '',
      value: formRef.values.value ?? '',
    };
    formRef.setValues(formValues);
    formRef.submitForm();
  };

  return (
    <>
      {!isEditing && (
        <Typography variant='body2' color='textSecondary' mb={2}>
          {Language.addLanguagelabel}
        </Typography>
      )}
      <StyledPaper elevation={3}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                disabled={isEditing}
                id={Language.isoCodeLabel}
                name={Language.isoCodeLabel}
                label={Language.ISOCodeLabel}
                value={isoCode ?? formRef.values?.isoCode ?? ''}
                onChange={formRef.handleChange}
                error={formRef.touched.isoCode && Boolean(formRef.errors.isoCode)}
                helperText={formRef.touched.isoCode && formRef.errors.isoCode}
                placeholder={Language.isoCodePlaceholder}
                variant='standard'
                size='small'
                fullWidth
                required
                margin='dense'
                style={{ width: '100%' }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                disabled={isEditing}
                id='key'
                name='key'
                label='Label'
                value={formRef.values?.key ?? ''}
                onChange={formRef.handleChange}
                error={formRef.touched.key && Boolean(formRef.errors.key)}
                helperText={formRef.touched.key && formRef.errors.key}
                placeholder={Language.enterLabel}
                variant='standard'
                size='small'
                fullWidth
                required
                margin='dense'
                style={{ width: '100%' }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                id={Language.valueLabel}
                name={Language.valueLabel}
                label='Value'
                value={formRef.values?.value ?? ''}
                onChange={formRef.handleChange}
                error={formRef.touched.value && Boolean(formRef.errors.value)}
                helperText={formRef.touched.value && formRef.errors.value}
                placeholder={Language.enterLabelValue}
                variant='standard'
                size='small'
                fullWidth
                required
                margin='dense'
                style={{ width: '100%' }}
              />
            </Grid>
          </Grid>
        </form>
      </StyledPaper>
    </>
  );
};

export default AddLanguage;
